import { Breadcrumb, Layout, Menu } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { Link, Route, Switch, useLocation } from 'react-router-dom'
import { DataCenter, getdataCenterName } from '../../models/dataCenter'
import { getSMenuTitleName } from '../../models/menuTitle'
import { DataAnaylse } from '../HealthPrisonAnaylse/DataAnaylse'
import { HealthProportionAnaylse } from '../HealthPrisonAnaylse/HealthProportionAnaylse'
import { HealthProportionContrast } from '../HealthPrisonAnaylse/HealthProportionContrast'
import { PrisonData } from '../HealthPrisonAnaylse/PrisonData/PrisonData'
import { MedicalData } from '../ProvinceDataAnalyse/MedicalData/MedicalData'
import { ProvinceProportionAnaylse } from '../ProvinceDataAnalyse/ProvinceProportionAnaylse'
import { ProvinceProportionContrast } from '../ProvinceDataAnalyse/ProvinceProportionContrast'
import { Anaylse } from '../WarningRulesAnaylse/Anaylse'
import { EnableRulesProportion } from '../WarningRulesAnaylse/EnableRulesProportion'
import { LawEnforcementAnaylse } from '../WarningRulesAnaylse/LawEnforcementAnaylse'
import { WarningRulesAnaylse } from '../WarningRulesAnaylse/WarningRulesAnaylse'
import styles from './statementLayout.module.css'

export const StatementLayout = (): ReactElement => {
  const location = useLocation()

  const [selectedKey, setSelectedKey] = useState<any>()

  const { Sider, Content } = Layout

  useEffect(() => {
    const paths = location.pathname.split('/')
    if (paths.length === 2) {
      setSelectedKey('pandect')
    } else if (
      paths.length >= 3 &&
      [
        'pandect',
        'analyse',
        'proportion',
        'wpandect',
        'wanalyse',
        'wcontrast',
        'wproportion',
        'dataTreating',
        'wraningRuleProportion',
        'regulatoryData',
      ].includes(paths[2])
    ) {
      setSelectedKey(paths[2])
    }
  }, [location])

  return (
    <>
      <Layout style={{ height: '100%', width: '100%' }}>
        <Sider width={240} style={{ background: '#fff' }}>
          <Menu
            theme='light'
            mode='inline'
            defaultSelectedKeys={['1']}
            selectedKeys={[selectedKey]}
            onSelect={({ key }) => setSelectedKey(key as string)}
            style={{ fontSize: '14px' }}
            className={styles.menu}
          >
            <Menu.ItemGroup
              title={getdataCenterName(DataCenter.Ssjzx)}
              className={styles.title}
            >
              <Menu.Item key='pandect'>
                <Link to='/statement/pandect'>监管数据总览</Link>
              </Menu.Item>
              <Menu.Item key='analyse'>
                <Link to='/statement/analyse'>监管数据变化分析</Link>
              </Menu.Item>
              <Menu.Item key='proportion'>
                <Link to='/statement/proportion'>监管数据占比分析</Link>
              </Menu.Item>
            </Menu.ItemGroup>
            <Menu.ItemGroup
              title={getdataCenterName(DataCenter.Wjssjzx)}
              className={styles.title}
            >
              <Menu.Item key='wpandect'>
                <Link to='/statement/wpandect'>监管数据总览</Link>
              </Menu.Item>
              <Menu.Item key='wanalyse'>
                <Link to='/statement/wanalyse'>监管数据变化分析</Link>
              </Menu.Item>
              <Menu.Item key='wcontrast'>
                <Link to='/statement/wcontrast'>监管数据对比分析</Link>
              </Menu.Item>
              <Menu.Item key='wproportion'>
                <Link to='/statement/wproportion'>监管数据占比分析</Link>
              </Menu.Item>
            </Menu.ItemGroup>
            <Menu.ItemGroup
              title={getdataCenterName(DataCenter.Yjgzyyfx)}
              className={styles.title}
            >
              <Menu.Item key='dataTreating'>
                <Link to='/statement/dataTreating'>规则启用占比分析</Link>
              </Menu.Item>
              <Menu.Item key='wraningRuleProportion'>
                <Link to='/statement/wraningRuleProportion'>
                  规则预警占比分析
                </Link>
              </Menu.Item>
              <Menu.Item key='regulatoryData'>
                <Link to='/statement/regulatoryData'>规则处置占比分析</Link>
              </Menu.Item>
            </Menu.ItemGroup>
          </Menu>
        </Sider>
        <Layout>
          <Breadcrumb
            style={{ position: 'relative', left: '20px', top: '10px' }}
          >
            <Breadcrumb.Item>数据分析</Breadcrumb.Item>
            <Breadcrumb.Item>
              {selectedKey === 'pandect' ||
              selectedKey === 'analyse' ||
              selectedKey === 'proportion'
                ? getdataCenterName(DataCenter.Ssjzx)
                : selectedKey === 'wpandect' ||
                  selectedKey === 'wanalyse' ||
                  selectedKey === 'wcontrast' ||
                  selectedKey === 'wproportion'
                ? getdataCenterName(DataCenter.Wjssjzx)
                : getdataCenterName(DataCenter.Yjgzyyfx)}
            </Breadcrumb.Item>
            <Breadcrumb.Item>{getSMenuTitleName(selectedKey)}</Breadcrumb.Item>
          </Breadcrumb>
          <Content
            style={{
              margin: '20px',
              minHeight: 280,
            }}
          >
            <Switch>
              <Route exact path={['/statement', '/statement/pandect']}>
                <MedicalData />
              </Route>
              {/* 省数据变化 */}
              <Route exact path='/statement/analyse'>
                <ProvinceProportionContrast />
              </Route>
              {/* 省监管数据占比分析 */}
              <Route exact path='/statement/wproportion'>
                <HealthProportionAnaylse />
              </Route>
              {/* 卫健委(局)数据变化 */}
              <Route exact path='/statement/wanalyse'>
                <HealthProportionContrast />
              </Route>
              {/* 卫健委(局)监管数据对比分析 */}
              <Route exact path='/statement/wcontrast'>
                <DataAnaylse />
              </Route>
              {/* 卫健委(局)监管数据占比分析 */}
              <Route exact path='/statement/proportion'>
                <ProvinceProportionAnaylse />
              </Route>
              {/* 规则启用占比 */}
              <Route exact path='/statement/dataTreating'>
                <EnableRulesProportion />
              </Route>
              {/* 预警规则占比 */}
              <Route exact path='/statement/wraningRuleProportion'>
                <WarningRulesAnaylse />
              </Route>
              {/* 规则执法占比 */}
              <Route exact path='/statement/regulatoryData'>
                {/* <LawEnforcementAnaylse /> */}
                <Anaylse />
              </Route>
              <Route exact path='/statement/wpandect'>
                <PrisonData />
              </Route>
            </Switch>
          </Content>
        </Layout>
      </Layout>
    </>
  )
}
